import { SITEINFO_CHECKLIST } from "./type";

const initalState = {
  siteInfoData: {},
};

const siteInfoReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITEINFO_CHECKLIST:
      return {
        ...state,
        siteInfoData: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default siteInfoReducer;
